/* eslint-disable */
import {
  GET_ALL_TEAMS,
  UPDATE_TEAM,
  CREATE_TEAM,
  GET_TEAM,
  PAGINATE_TEAMS,
  ADD_USER,
  DELETE_USER,
  GET_TEAMS_FILTERED,
} from "../actionTypes";

const initialState: TeamsState = {
  teams: [],
};

const TeamsReducer = (
  state: TeamsState = initialState,
  action: TeamsAction
) => {
  switch (action.type) {
    case GET_ALL_TEAMS:
      return {
        ...state,
        teams: action.payload,
      };
    case GET_TEAM:
      return {
        ...state,
        team: action.payload,
      };
    case UPDATE_TEAM:
      return {
        ...state,
        return: action.payload,
      };
    case GET_TEAMS_FILTERED:
      return {
        ...state,
        teams: action.payload,
      };
    case CREATE_TEAM:
      return {
        ...state,
      };
    case PAGINATE_TEAMS:
      return {
        ...state,
        teams: action.payload,
      };
    case ADD_USER:
      return {
        ...state,
      };
    case DELETE_USER:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default TeamsReducer;
